import Hicard from './HiCard/index.vue'
import HiFlowApproval from './HiFlowApproval/index.vue'
import HiAttachment from './HiAttachment/index.vue'
import HiCell from './HiCell/index.vue'

const components = [Hicard, HiFlowApproval, HiAttachment, HiCell]

const plugins = {
  install(Vue) {
    components.map(component => Vue.component(component.name, component))
  }
}

export default plugins
